// This action enables the step button to only be clicked at certain times, prevents rapidly hitting enter and breaking form

import StepProgressionActions from './constants';

interface ActionObject {
  type: string;
  data?: any;
}

// Enables step button
export function enableStepProgression(): ActionObject {
  return {
    type: StepProgressionActions.ENABLE_PROGRESSION,
    data: { stepProgression: true },
  };
}

// Disables step button
export function disableStepProgression(): ActionObject {
  return {
    type: StepProgressionActions.DISABLE_PROGRESSION,
    data: { stepProgression: false },
  };
}
